import { Result } from "../models/interfaces";
import { BaseService } from "./BaseService";

export type AccountGroup = {
  id?: number;
  name?: string;
  code?: string;
  parentGroupId?: number;
};

export class AccountGroupService extends BaseService {
  //region : Account groups services
  async getAccountGroups(params: {
    id?: number[];
    name?: string;
    code?: string;
    pageNo?: number;
    pageSize?: number;
  }): Promise<Result<AccountGroup[]>> {
    let queryParams = this.ToQueryString(params);
    return this.get<Result<AccountGroup[]>>(`accountGroups${queryParams}`);
  }

  async getAccountGroup(id: number): Promise<Result<AccountGroup | any> | any> {
    return this.get<Result<AccountGroup>>(`accountGroups/${id}`);
  }

  async deleteAccountGroup(id: number): Promise<Result<boolean>> {
    return this.delete<Result<boolean>>(`accountGroups/${id}`);
  }

  async disableOrEnableAccountGroup(
    id: number,
    value: boolean
  ): Promise<Result<boolean>> {
    const action: string = value ? "disabled" : "enabled";
    return this.patch(`accountGroups/${id}/${action}`, value);
  }

  async createOrUpdateAccountGroup(
    accountGroup: AccountGroup
  ): Promise<Result<AccountGroup | boolean | undefined | any> | undefined> {
    if (accountGroup.id && accountGroup.id >= 1) {
      return this.put(`accountGroups/${accountGroup.id}`, {
        name: accountGroup.name,
        code: accountGroup.code,
        parentGroupId: accountGroup.parentGroupId,
      });
    } else {
      return this.post(`accountGroups`, accountGroup);
    }
  }
}

export default new AccountGroupService();
